import React from 'react';
import { TitleHeader } from 'web-library';
import ResitInstruction from '../../modules/resit/components/@candidate/ResitInstruction';

interface InstructionProps {
  title: string;
}

const Instruction = ({ title = '' }: InstructionProps) => (
  <>
    <TitleHeader title={title} />

    <ResitInstruction />
  </>
);

export default Instruction;
